export const USER_METRIC_PARAMETERS = {
  totalUserActivity: 'total_user_activity',
  tickets: 'tickets',
  ackAlarmWithoutCancel: 'ack_alarms_without_cancel',
  averageUserSession: 'average_user_session',
  minUserSession: 'min_user_session',
  maxUserSession: 'max_user_session',
};

export const USERS_TABS = {
  users: 'users',
  shareTokens: 'shareTokens',
};

export const USER_PAYLOADS_VARIABLES = {
  email: '.User.Email',
  username: '.User.Username',
  firstname: '.User.Firstname',
  lastname: '.User.Lastname',
  externalId: '.User.ExternalID',
  source: '.User.Source',
  role: '.User.Roles',
};
